import React from "react";
import PropTypes from "prop-types";
import Routes from "routes";
import MembershipAcquisitionMessaging from "components/source/acquisition/membership-acquisition-messaging";

class UnlimitedAcquisitionMessaging extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    loggingLocation: PropTypes.string,
    acquisitionMessaging: PropTypes.shape({
      title: PropTypes.string,
      dek: PropTypes.string,
      list: PropTypes.arrayOf(PropTypes.string),
      cta: PropTypes.string,
      promo: PropTypes.string,
      secondaryCta: PropTypes.string,
      hasSkuInBag: PropTypes.bool,
    }),
  };

  static defaultProps = {
    acquisitionMessaging: {
      title: "Want a closet on rotation?",
      dek: "Unlock unlimited rentals for $159/month.",
      list: [
        "Rent 4 pieces on constant rotation",
        "Swap anytime, no set return dates",
        "Choose from 450+ top brands",
        "Free shipping, insurance and dry cleaning",
      ],
      cta: "Try Unlimited",
      secondaryCta: "Learn More",
    },
  };

  render() {
    const membershipType = "unlimited";
    const acquisitionMessaging = this.props.acquisitionMessaging;
    if (!acquisitionMessaging) {
      return;
    }

    const { title, dek, list, promo, cta, primaryCtaUrl, secondaryCta, primaryCtaAddsToBag } = acquisitionMessaging;
    const url = this.props.acquisitionMessaging.url || Routes.LP.unlimited;
    const addToBagUrl = Routes.AddToBag.unlimited;
    const hasSkuInBag = this.props.acquisitionMessaging?.hasSkuInBag ?? false;

    return (
      <MembershipAcquisitionMessaging
        product={this.props.product}
        membershipType={membershipType}
        loggingLocation={this.props.loggingLocation}
        title={title}
        dek={dek}
        list={list}
        promo={promo}
        cta={cta}
        primaryCtaUrl={primaryCtaUrl}
        secondaryCta={secondaryCta}
        url={url}
        addToBagUrl={addToBagUrl}
        hasSkuInBag={hasSkuInBag}
        primaryCtaAddsToBag={primaryCtaAddsToBag}
      />
    );
  }
}

export default UnlimitedAcquisitionMessaging;
